<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <div class="header-left">
          <button class="back-btn" @click="goBack" title="Orqaga">
            <b-icon icon="arrow-left"></b-icon>
          </button>
          <h2 class="page-title">Yangi buyurtma</h2>
          <span v-if="newOrder.kontragent_id" class="sale-type-badge" :class="clientSaleType">
            {{ clientSaleType === 'optom' ? 'OPTOM' : 'CHAKANA' }}
          </span>
        </div>
      </div>

      <!-- BODY — 2 USTUN -->
      <div class="form-card">
        <div class="order-body">

          <!-- ==== CHAP PANEL: Tanlash ==== -->
          <div class="panel-left">

            <!-- Mijoz + ma'lumotlar -->
            <div class="panel-section">
              <div class="row-2">
                <div class="form-group">
                  <label>Mijoz</label>
                  <select v-model="newOrder.kontragent_id" class="form-input" @change="onNewOrderClientChange">
                    <option :value="null">Tanlang...</option>
                    <option v-for="c in clientList" :key="c.id" :value="c.id">{{ c.name }} ({{ c.phone_number }})</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Telefon</label>
                  <input v-model="newOrder.phone_number" type="text" class="form-input" placeholder="+998...">
                </div>
              </div>
              <div class="row-2">
                <div class="form-group">
                  <label>Manzil</label>
                  <input v-model="newOrder.address" type="text" class="form-input" placeholder="Manzil...">
                </div>
                <div class="form-group">
                  <label>Usta (ixtiyoriy)</label>
                  <select v-model="newOrder.staff_id" class="form-input">
                    <option :value="null">Tanlang...</option>
                    <option v-for="u in ustaList" :key="u.id" :value="u.id">
                      {{ u.name }}{{ u.phone_number ? ' (' + u.phone_number + ')' : '' }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row-2">
                <div class="form-group" style="grid-column: 1 / -1;">
                  <label>Izoh</label>
                  <input v-model="newOrder.comment" type="text" class="form-input" placeholder="Izoh...">
                </div>
              </div>
            </div>

            <!-- Navigatsiya bar: Breadcrumb + Qidiruv + Tablar -->
            <div class="nav-bar">
              <div class="nav-inner">
                <!-- Breadcrumb -->
                <nav class="breadcrumb-nav">
                  <a href="#" @click.prevent="resetBrowse">Brendlar</a>
                  <template v-if="showAllItems && !selectedBrand">
                    <span class="bc-sep">/</span><span class="bc-current">Barchasi</span>
                  </template>
                  <template v-if="selectedBrand">
                    <span class="bc-sep">/</span>
                    <a href="#" @click.prevent="backToBrand">{{ selectedBrand.name }}</a>
                  </template>
                  <template v-if="selectedModel">
                    <span class="bc-sep">/</span><span class="bc-current">{{ selectedModel.name }}</span>
                  </template>
                </nav>

                <!-- Qidiruv -->
                <input
                  v-if="selectedModel || showAllItems"
                  type="text"
                  v-model="productKeyword"
                  @input="onBrowseSearch"
                  class="nav-search"
                  placeholder="Qidirish..."
                >

                <!-- Tab tugmalari -->
                <div v-if="selectedModel || showAllItems" class="nav-tabs">
                  <button :class="['nav-tab-btn', browseTab === 'service' ? 'active' : '']" @click="browseTab = 'service'">Xizmatlar</button>
                  <button :class="['nav-tab-btn', browseTab === 'product' ? 'active' : '']" @click="switchToProductTab">Mahsulotlar</button>
                </div>
              </div>
            </div>

            <!-- Browse content -->
            <div class="browse-content">

              <!-- 1. Brendlar gridi -->
              <div v-if="!selectedBrand && !showAllItems" class="browse-grid brand-grid">
                <div class="browse-card all-card" @click="showAllBrowse">
                  <span class="all-icon">&#9776;</span>
                  <span class="bc-name" style="text-align:center">Barchasi</span>
                </div>
                <div v-for="b in brandList" :key="b.id" class="browse-card brand-card" @click="selectBrowseBrand(b)">
                  <img v-if="b.image" :src="imageUrl + b.image" alt="" class="brand-img">
                  <span class="bc-name" style="text-align:center">{{ b.name }}</span>
                </div>
              </div>

              <!-- 2. Modellar gridi -->
              <div v-else-if="selectedBrand && !selectedModel && !showAllItems" class="browse-grid brand-grid">
                <div v-for="m in modelList" :key="m.id" class="browse-card brand-card" @click="selectBrowseModel(m)">
                  <img v-if="m.image" :src="imageUrl + m.image" alt="" class="brand-img">
                  <span class="bc-name" style="text-align:center">{{ m.name }}</span>
                </div>
                <div v-if="modelList.length === 0" class="browse-empty">
                  Modellar topilmadi
                </div>
              </div>

              <!-- 3. Xizmatlar yoki Mahsulotlar -->
              <template v-else>

                <!-- Xizmat paketlari -->
                <div v-if="browseTab === 'service'" class="browse-grid">
                  <div
                    v-for="pkg in filteredPackages" :key="pkg.id"
                    class="browse-card pkg-card"
                    :class="{ 'browse-card-added': isServiceInCart(pkg.id) }"
                    @click="addOrderService(pkg)"
                  >
                    <div class="bc-name">{{ pkg.name }}</div>
                    <div v-if="pkg.model" class="bc-meta">
                      <span class="bc-balance">{{ pkg.model.name }}</span>
                    </div>
                    <div class="bc-prices">
                      <span class="bc-price" :class="{ active: clientSaleType === 'chakana' }">
                        Ch: {{ formatMoney(Number(pkg.labor_price_chakana || 0) + Number(pkg.redo_price_chakana || 0)) }}
                      </span>
                      <span class="bc-price" :class="{ active: clientSaleType === 'optom' }">
                        Op: {{ formatMoney(Number(pkg.labor_price_optom || 0) + Number(pkg.redo_price_optom || 0)) }}
                      </span>
                    </div>
                    <div v-if="pkg.items && pkg.items.length > 0" class="bc-materials">
                      {{ pkg.items.length }} material
                    </div>
                    <div v-if="isServiceInCart(pkg.id)" class="bc-check">&#10003;</div>
                  </div>
                  <div v-if="filteredPackages.length === 0" class="browse-empty">Xizmat paketlari topilmadi</div>
                </div>

                <!-- Mahsulotlar -->
                <div v-else class="browse-grid">
                  <div
                    v-for="p in searchedProducts" :key="p.id"
                    class="browse-card"
                    :class="{ 'browse-card-added': isProductInCart(p.id) }"
                    @click="addOrderProduct(p)"
                  >
                    <div class="bc-name">{{ p.name || p.extra_name }}</div>
                    <div class="bc-meta">
                      <span class="bc-balance">Qoldiq: {{ p.balance || 0 }}</span>
                    </div>
                    <div class="bc-prices">
                      <span class="bc-price" :class="{ active: clientSaleType === 'chakana' }">
                        Ch: {{ formatMoney(p.price_register ? p.price_register.chakana_price : 0) }}
                      </span>
                      <span class="bc-price" :class="{ active: clientSaleType === 'optom' }">
                        Op: {{ formatMoney(p.price_register ? p.price_register.optom_price : 0) }}
                      </span>
                    </div>
                    <div v-if="isProductInCart(p.id)" class="bc-check">&#10003;</div>
                  </div>
                  <div v-if="searchedProducts.length === 0" class="browse-empty">Mahsulot topilmadi</div>
                </div>

              </template>
            </div>
          </div>

          <!-- ==== O'NG PANEL: Savatcha ==== -->
          <div class="panel-right">
            <div class="cart-title">
              Savatcha
              <span class="cart-count">{{ newOrder.products.length + newOrder.services.length }}</span>
            </div>

            <!-- Savatcha bo'sh -->
            <div v-if="newOrder.products.length === 0 && newOrder.services.length === 0" class="cart-empty">
              Chapdan mahsulot yoki xizmat tanlang
            </div>

            <div class="cart-list">
              <!-- Mahsulotlar -->
              <div v-for="(p, idx) in newOrder.products" :key="'p-' + idx" class="cart-item">
                <div class="ci-top">
                  <span class="ci-name">{{ p.name }}</span>
                  <button class="ci-remove" @click="newOrder.products.splice(idx, 1)">&times;</button>
                </div>
                <div class="ci-bottom">
                  <div class="ci-qty">
                    <button class="qty-btn" @click="p.count > 1 ? p.count-- : null">-</button>
                    <span class="qty-val">{{ p.count }}</span>
                    <button class="qty-btn" @click="p.count++">+</button>
                  </div>
                  <span class="ci-price">{{ formatMoney(p.price * p.count) }}</span>
                </div>
              </div>

              <!-- Xizmatlar -->
              <div v-for="(s, idx) in newOrder.services" :key="'s-' + idx" class="cart-item cart-service">
                <div class="ci-top">
                  <span class="ci-name">{{ s.name }}</span>
                  <button class="ci-remove" @click="removeOrderService(idx)">&times;</button>
                </div>
                <div class="ci-bottom">
                  <span class="ci-badge">Xizmat</span>
                  <span class="ci-price">{{ formatMoney(s.price + s.product_summa) }}</span>
                </div>
                <!-- Materiallar -->
                <div
                  v-for="(sp, spIdx) in newOrder.serviceProducts.filter(x => x.from_service === s.package_id)"
                  :key="'sp-' + spIdx"
                  class="ci-material"
                >
                  <span>↳ {{ sp.name }} ({{ sp.count }})</span>
                  <span>{{ formatMoney(sp.price * sp.count) }}</span>
                </div>
              </div>
            </div>

            <!-- JAMI + TUGMA -->
            <div class="cart-footer">
              <div class="cart-total">
                <span>Jami:</span>
                <span class="total-value">{{ formatMoney(newOrderTotal) }} so'm</span>
              </div>
              <button class="submit-btn" @click="submitNewOrder" :disabled="creatingOrder">
                {{ creatingOrder ? 'Saqlanmoqda...' : 'Savatni saqlash' }}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ZakazForm',
  data() {
    return {
      creatingOrder: false,
      clientList: [],
      ustaList: [],
      brandList: [],
      modelList: [],
      packageList: [],
      searchedProducts: [],
      productKeyword: '',
      browseTab: 'service',
      selectedBrandId: null,
      selectedModelId: null,
      selectedBrand: null,
      selectedModel: null,
      showAllItems: false,
      imageUrl: process.env.VUE_APP_BASE_URL + 'api/v1/uploads/',
      newOrder: {
        kontragent_id: null,
        staff_id: null,
        phone_number: '',
        address: '',
        comment: '',
        products: [],
        services: [],
        serviceProducts: [],
      },
    };
  },
  computed: {
    clientSaleType() {
      if (!this.newOrder.kontragent_id) return 'chakana';
      const client = this.clientList.find(c => c.id === this.newOrder.kontragent_id);
      return client?.sale_type || 'chakana';
    },
    newOrderTotal() {
      const prodTotal = this.newOrder.products.reduce((s, p) => s + p.price * p.count, 0);
      const srvTotal = this.newOrder.services.reduce((s, srv) => s + (srv.price || 0) + (srv.product_summa || 0), 0);
      return prodTotal + srvTotal;
    },
    filteredPackages() {
      if (!this.productKeyword) return this.packageList;
      const kw = this.productKeyword.toLowerCase();
      return this.packageList.filter(p => (p.name || '').toLowerCase().includes(kw));
    },
  },
  async mounted() {
    try {
      const res = await axios.get('api/v1/kontragent/type/1');
      this.clientList = res.data || [];
    } catch (e) { this.clientList = []; }
    try {
      const res = await axios.get('api/v1/brand/');
      this.brandList = res.data || [];
    } catch (e) { this.brandList = []; }
    try {
      const res = await axios.get('api/v1/staff');
      const raw = Array.isArray(res.data && res.data.data) ? res.data.data : (res.data || []);
      this.ustaList = raw.filter((s) => (s.position || '').toLowerCase() === 'usta');
    } catch (e) { this.ustaList = []; }
  },
  methods: {
    goBack() {
      this.$router.push('/zakazlar/index');
    },
    formatMoney(v) {
      if (!v) return '0';
      return Number(v).toLocaleString('ru-RU').replace(/,/g, ' ');
    },
    onNewOrderClientChange() {
      const client = this.clientList.find(c => c.id === this.newOrder.kontragent_id);
      if (client) {
        this.newOrder.phone_number = client.phone_number || '';
        this.updateOrderPrices();
      }
    },
    updateOrderPrices() {
      const type = this.clientSaleType;
      for (const p of this.newOrder.products) {
        if (p.price_chakana !== undefined) {
          p.price = type === 'optom' ? Number(p.price_optom || 0) : Number(p.price_chakana || 0);
        }
      }
      for (const sp of this.newOrder.serviceProducts) {
        sp.price = type === 'optom' ? Number(sp.price_optom || 0) : Number(sp.price_chakana || 0);
      }
      for (const srv of this.newOrder.services) {
        const srvProducts = this.newOrder.serviceProducts.filter(p => p.from_service === srv.package_id);
        srv.product_summa = srvProducts.reduce((s, p) => s + p.price * p.count, 0);
        const labor = type === 'optom' ? srv.labor_price_optom : srv.labor_price_chakana;
        const redo = type === 'optom' ? srv.redo_price_optom : srv.redo_price_chakana;
        srv.price = labor + redo;
      }
    },
    getProductPrice(p) {
      const pr = p.price_register;
      if (!pr) return 0;
      return this.clientSaleType === 'optom' ? Number(pr.optom_price || 0) : Number(pr.chakana_price || 0);
    },
    addOrderProduct(p) {
      const existing = this.newOrder.products.find(x => x.product_id === p.id && !x.from_service);
      if (existing) {
        existing.count++;
        return;
      }
      const pr = p.price_register;
      this.newOrder.products.push({
        product_id: p.id,
        name: p.name || p.extra_name,
        count: 1,
        price: this.getProductPrice(p),
        price_chakana: pr ? Number(pr.chakana_price || 0) : 0,
        price_optom: pr ? Number(pr.optom_price || 0) : 0,
        shtrix_kod: p.shtrix_kod || '',
      });
    },
    resetBrowse() {
      this.selectedBrand = null;
      this.selectedModel = null;
      this.showAllItems = false;
      this.selectedBrandId = null;
      this.selectedModelId = null;
      this.modelList = [];
      this.packageList = [];
      this.searchedProducts = [];
      this.productKeyword = '';
    },
    async selectBrowseBrand(brand) {
      this.selectedBrand = brand;
      this.selectedBrandId = brand.id;
      this.selectedModel = null;
      this.selectedModelId = null;
      this.showAllItems = false;
      this.modelList = [];
      this.packageList = [];
      try {
        const res = await axios.get(`api/v1/model/?brand_id=${brand.id}`);
        this.modelList = res.data || [];
      } catch (e) { this.modelList = []; }
    },
    async selectBrowseModel(model) {
      this.selectedModel = model;
      this.selectedModelId = model.id;
      this.browseTab = 'service';
      this.productKeyword = '';
      await Promise.all([this.fetchPackages(), this.fetchModelProducts()]);
    },
    async showAllBrowse() {
      this.showAllItems = true;
      this.selectedBrand = null;
      this.selectedModel = null;
      this.selectedBrandId = null;
      this.selectedModelId = null;
      this.browseTab = 'service';
      this.productKeyword = '';
      await Promise.all([this.fetchPackages(), this.fetchModelProducts()]);
    },
    backToBrand() {
      this.selectedModel = null;
      this.selectedModelId = null;
      this.showAllItems = false;
      this.packageList = [];
      this.searchedProducts = [];
      this.productKeyword = '';
    },
    async switchToProductTab() {
      this.browseTab = 'product';
      if (this.searchedProducts.length === 0) {
        await this.fetchModelProducts();
      }
    },
    async onBrowseSearch() {
      if (this.browseTab === 'product') {
        await this.fetchModelProducts();
      }
    },
    async fetchModelProducts() {
      try {
        const sklad_id = localStorage.getItem('sklad_id');
        const res = await axios.post('api/v1/product/all-price-balance/0', {
          sklad_id,
          keyword: this.productKeyword || '',
          model_id: this.selectedModelId || 0,
          brand_id: this.selectedBrandId || 0,
          limit: 50,
          page: 1,
        });
        this.searchedProducts = res.data || [];
      } catch (e) { this.searchedProducts = []; }
    },
    async fetchPackages() {
      this.packageList = [];
      const modelId = this.selectedModelId || 0;
      try {
        const res = await axios.get(`api/v1/repair_package?model_id=${modelId}`);
        this.packageList = res.data || [];
      } catch (e) { this.packageList = []; }
    },
    addOrderService(pkg) {
      if (this.newOrder.services.find(s => s.package_id === pkg.id)) return;
      const type = this.clientSaleType;
      const labor = type === 'optom' ? Number(pkg.labor_price_optom || 0) : Number(pkg.labor_price_chakana || 0);
      const redo = type === 'optom' ? Number(pkg.redo_price_optom || 0) : Number(pkg.redo_price_chakana || 0);
      const product_summa = (pkg.items || []).reduce((s, i) => {
        const ip = type === 'optom' ? Number(i.price_optom || 0) : Number(i.price_chakana || 0);
        return s + ip * (i.quantity || 1);
      }, 0);
      this.newOrder.services.push({
        package_id: pkg.id,
        name: pkg.name,
        price: labor + redo,
        labor_price_chakana: Number(pkg.labor_price_chakana || 0),
        redo_price_chakana: Number(pkg.redo_price_chakana || 0),
        labor_price_optom: Number(pkg.labor_price_optom || 0),
        redo_price_optom: Number(pkg.redo_price_optom || 0),
        product_summa,
      });
      if (pkg.items && pkg.items.length > 0) {
        for (const item of pkg.items) {
          const ip = type === 'optom' ? Number(item.price_optom || 0) : Number(item.price_chakana || 0);
          this.newOrder.serviceProducts.push({
            product_id: item.product_id,
            name: item.product?.name || 'Mahsulot',
            count: item.quantity || 1,
            price: ip,
            price_chakana: Number(item.price_chakana || 0),
            price_optom: Number(item.price_optom || 0),
            from_service: pkg.id,
          });
        }
      }
    },
    removeOrderService(idx) {
      const srv = this.newOrder.services[idx];
      this.newOrder.services.splice(idx, 1);
      this.newOrder.serviceProducts = this.newOrder.serviceProducts.filter(p => p.from_service !== srv.package_id);
    },
    isProductInCart(id) {
      return this.newOrder.products.some(p => p.product_id === id && !p.from_service);
    },
    isServiceInCart(id) {
      return this.newOrder.services.some(s => s.package_id === id);
    },
    async submitNewOrder() {
      if (this.newOrder.products.length === 0 && this.newOrder.services.length === 0) {
        return alert('Kamida bitta mahsulot yoki xizmat tanlang!');
      }
      this.creatingOrder = true;
      try {
        const payload = {
          kontragent_id: this.newOrder.kontragent_id,
          staff_id: this.newOrder.staff_id || null,
          phone_number: this.newOrder.phone_number,
          address: this.newOrder.address,
          comment: this.newOrder.comment || 'Admin tomonidan yaratildi',
          lat: '', long: '',
          products: this.newOrder.products
            .filter(p => !p.from_service)
            .map(p => ({
              product_id: p.product_id,
              count: p.count,
              price: p.price,
              shtrix_kod: p.shtrix_kod || '',
            })),
          services: this.newOrder.services.map(s => ({
            package_id: s.package_id,
            name: s.name,
            price: s.price,
            labor_price_chakana: s.labor_price_chakana,
            redo_price_chakana: s.redo_price_chakana,
            labor_price_optom: s.labor_price_optom,
            redo_price_optom: s.redo_price_optom,
            product_summa: s.product_summa,
          })),
        };
        await axios.post('/api/v1/bron/makeOrder', payload);
        this.$router.push('/zakazlar/index');
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || 'Buyurtma yaratishda xato'));
      } finally {
        this.creatingOrder = false;
      }
    },
  }
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
}

.back-btn {
  width: 40px; height: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #475569;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px;
  transition: 0.15s;
}
.back-btn:hover {
  background: #f5f3ff;
  color: #a142f4;
  border-color: #a142f4;
}

.sale-type-badge {
  padding: 4px 14px; border-radius: 8px;
  font-size: 11px; font-weight: 800; letter-spacing: 1px;
}
.sale-type-badge.chakana { background: #dbeafe; color: #2563eb; }
.sale-type-badge.optom { background: #fef3c7; color: #d97706; }

.form-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.04);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.order-body {
  display: flex;
  flex: 1;
  min-height: 0;
}

/* CHAP PANEL */
.panel-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #f1f5f9;
  min-width: 0;
}
.panel-section {
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
}

/* Browse content */
.browse-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  min-height: 0;
}

/* Card grid */
.browse-grid {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
  align-content: start;
}
.browse-card {
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 12px;
  cursor: pointer;
  transition: 0.15s;
  position: relative;
}
.browse-card:hover {
  border-color: #a142f4;
  background: #faf8ff;
  box-shadow: 0 2px 8px rgba(161,66,244,0.08);
}
.browse-card-added {
  border-color: #10b981 !important;
  background: #ecfdf5 !important;
}
.browse-card.pkg-card { border-left: 3px solid #a142f4; }
.bc-name {
  font-weight: 700; font-size: 13px; color: #1e293b;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.bc-meta { margin-top: 2px; }
.bc-balance { font-size: 11px; color: #94a3b8; }
.bc-prices {
  display: flex; gap: 8px; margin-top: 6px;
}
.bc-price {
  font-size: 11px; font-weight: 700;
  padding: 2px 6px; border-radius: 6px;
  background: #f1f5f9; color: #64748b;
}
.bc-price.active {
  background: #ecfdf5; color: #059669;
}
.bc-materials {
  margin-top: 4px; font-size: 10px; color: #a142f4; font-weight: 700;
}
.bc-check {
  position: absolute; top: 8px; right: 8px;
  width: 22px; height: 22px; border-radius: 50%;
  background: #10b981; color: white;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: bold;
}
.browse-empty {
  grid-column: 1 / -1;
  text-align: center; padding: 30px 0;
  color: #94a3b8; font-size: 13px;
}

/* O'NG PANEL — Savatcha */
.panel-right {
  width: 360px;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  background: #fafbfc;
}
.cart-title {
  padding: 14px 20px;
  font-weight: 800; font-size: 15px; color: #1e293b;
  border-bottom: 1px solid #f1f5f9;
  display: flex; align-items: center; gap: 8px;
  flex-shrink: 0;
}
.cart-count {
  background: #a142f4; color: white;
  padding: 2px 8px; border-radius: 10px;
  font-size: 11px; font-weight: 800;
}
.cart-empty {
  flex: 1; display: flex; align-items: center; justify-content: center;
  color: #cbd5e1; font-size: 13px; padding: 20px;
  text-align: center;
}
.cart-list {
  flex: 1; overflow-y: auto;
  padding: 10px 14px;
}

/* Cart items */
.cart-item {
  background: white;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 6px;
  border: 1px solid #e2e8f0;
}
.cart-service {
  border-left: 3px solid #a142f4;
  background: #faf8ff;
}
.ci-top {
  display: flex; justify-content: space-between; align-items: start;
  margin-bottom: 6px;
}
.ci-name {
  font-weight: 700; font-size: 13px; color: #1e293b;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  flex: 1;
}
.ci-remove {
  background: none; border: none; color: #cbd5e1;
  font-size: 18px; cursor: pointer; line-height: 1;
  padding: 0 0 0 8px;
}
.ci-remove:hover { color: #ef4444; }
.ci-bottom {
  display: flex; justify-content: space-between; align-items: center;
}
.ci-badge {
  font-size: 10px; font-weight: 800;
  padding: 2px 8px; border-radius: 6px;
  background: #f5f0ff; color: #a142f4;
}
.ci-qty {
  display: flex; align-items: center;
  background: #f8fafc; border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.ci-price {
  font-weight: 800; font-size: 14px; color: #1e293b;
}
.ci-material {
  display: flex; justify-content: space-between;
  font-size: 11px; color: #94a3b8;
  padding: 3px 0 0 12px;
  border-top: 1px solid #f1f5f9;
  margin-top: 4px;
}
.qty-btn {
  width: 26px; height: 26px; border: none; background: none;
  font-weight: bold; font-size: 15px; cursor: pointer; color: #475569;
  display: flex; align-items: center; justify-content: center;
}
.qty-btn:hover { color: #a142f4; }
.qty-val {
  font-weight: 800; min-width: 24px; text-align: center;
  font-size: 13px;
}

/* Cart footer */
.cart-footer {
  padding: 14px 20px;
  border-top: 2px solid #e2e8f0;
  flex-shrink: 0;
}
.cart-total {
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 12px;
  font-weight: 800; font-size: 16px;
}
.total-value { color: #a142f4; }
.submit-btn {
  width: 100%; padding: 14px; border: none; border-radius: 14px;
  background: linear-gradient(135deg, #a142f4, #7c3aed);
  color: white; font-weight: 800; font-size: 14px;
  cursor: pointer; letter-spacing: 0.5px;
  box-shadow: 0 4px 14px rgba(161,66,244,0.3);
  transition: 0.2s;
}
.submit-btn:hover { box-shadow: 0 6px 20px rgba(161,66,244,0.4); }
.submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* Form elements */
.form-group { margin-bottom: 10px; }
.form-group label {
  display: block; font-size: 11px; font-weight: 700;
  color: #64748b; margin-bottom: 3px; text-transform: uppercase;
}
.form-input {
  width: 100%; border: 1px solid #e2e8f0; border-radius: 10px;
  padding: 8px 12px; font-size: 13px; outline: none;
}
.form-input:focus { border-color: #a142f4; box-shadow: 0 0 0 3px rgba(161,66,244,0.1); }
.row-2 { display: flex; gap: 10px; }
.row-2 > * { flex: 1; }

/* NAV BAR */
.nav-bar {
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
  background: #fafbfc;
}
.nav-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px;
  flex-wrap: wrap;
}
.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 700;
}
.breadcrumb-nav a {
  color: #a142f4;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-nav a:hover { text-decoration: underline; }
.bc-sep { color: #cbd5e1; margin: 0 2px; }
.bc-current { color: #475569; }
.nav-search {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 5px 12px;
  font-size: 12px;
  outline: none;
  width: 180px;
  flex-shrink: 0;
}
.nav-search:focus { border-color: #a142f4; }
.nav-tabs {
  display: flex;
  gap: 4px;
  margin-left: auto;
}
.nav-tab-btn {
  padding: 5px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
  transition: 0.15s;
}
.nav-tab-btn.active {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
}
.nav-tab-btn:hover:not(.active) { border-color: #a142f4; color: #a142f4; }

/* BRAND / MODEL GRID */
.brand-grid {
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
}
.brand-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 8px;
}
.brand-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  border-radius: 8px;
}
.all-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 8px;
  background: #f0f0ff;
  border-color: #c4b5fd;
}
.all-card:hover { background: #e8e5ff; }
.all-icon {
  font-size: 28px;
  color: #a142f4;
}
</style>
